import { useCallback } from 'react';
import { useQueryClient } from 'react-query';

import { useUserFetch } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/user/useUserFetch';
import { useUserProfilesFetch } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/user/useUserProfilesFetch';
import {
    resetUserPseudoId,
    setUserDataToStorage,
    useUserData,
} from '@24i/nxg-sdk-smartott-shared/src/context/UserData';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';

import { useStore } from '../../../../context/ApplicationStore';
import { useStartPageNavigation } from '../../../../context/AppStartContext/hooks';

export const useAuthOpenID = () => {
    const queryClient = useQueryClient();
    const userDataClient = useUserData();
    const { setUserData, setProfilesAndPossiblySelectOne } = useStore();
    const { navigateToStartPage } = useStartPageNavigation();
    const { fetch: fetchUser } = useUserFetch();
    const { fetch: fetchUserProfiles } = useUserProfilesFetch();
    const profilesEnabled = useFeature('accounts')?.select_profiles || false;

    const login = useCallback(async () => {
        await queryClient.invalidateQueries();

        const user = await fetchUser();

        setUserData(user);
        await resetUserPseudoId();
        await setUserDataToStorage(user);
        if (user && profilesEnabled) {
            const profiles = await fetchUserProfiles();
            setProfilesAndPossiblySelectOne(profiles);
        }

        await navigateToStartPage();
    }, [queryClient, userDataClient]);

    return { login };
};
